var _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRewardCoin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.9102,
    cy: 12.6973,
    r: 10,
    fill: "url(#paint0_linear_5027_456)",
    stroke: "#FFD66C",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0817 12.0945H14.7837C14.6627 13.0955 14.0467 13.6785 12.6057 13.8105L15.0807 16.7695H13.3427L10.9447 13.8435V13.1725H11.5607C12.5727 13.1725 13.0567 12.8315 13.1667 12.0945H10.9447V11.3795H13.1777C13.0787 10.6095 12.6057 10.3235 11.5717 10.3235H10.9447V9.61953H16.0817V10.3235H14.2887C14.5747 10.5765 14.7397 10.9285 14.7947 11.3795H16.0817V12.0945Z",
    fill: "#AF5700"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5027_456",
    x1: 12.9102,
    y1: 0.697266,
    x2: 12.9102,
    y2: 24.6973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardCoin);
export default __webpack_public_path__ + "static/media/reward-coin.c1e5eea16b7ffb594c06e6852a948aab.svg";
export { ForwardRef as ReactComponent };